"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CardButtonWrapper = function CardButtonWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "shortcutSettings", _descriptor, _this);
      _initializerDefineProperty(_this, "rateLimited", _descriptor2, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearTimeout(this.dispose);
      }
    }, {
      key: "showTooltip",
      get: function get() {
        return this.props.tooltip && !_state.DeckUI.layout.isMobile;
      }
    }, {
      key: "wrongAnswer",
      get: function get() {
        return this.props.showResult && !this.props.correctAnswer;
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        return this.props.showResult && this.props.correctAnswer;
      }
    }, {
      key: "disabled",
      get: function get() {
        return this.props.disabled || this.temporarilyDisabled;
      }
    }, {
      key: "backgroundColor",
      get: function get() {
        if (this.wrongAnswer) {
          return _constants.Theme.red;
        }
        if (this.correctAnswer) {
          return _constants.Theme.green;
        }
        if (this.props.disabled) {
          return this.props.disabledBackgroundColor || _constants.Theme.gray;
        }
        if (this.props.backgroundColor) {
          return this.props.backgroundColor;
        }
        return _constants.Theme.green;
      }
    }, {
      key: "color",
      get: function get() {
        if (this.props.disabled && this.props.disabledColor) {
          return this.props.disabledColor;
        }
        if (this.props.disabled) {
          return '#989898';
        }
        if (this.props.showResult) {
          return '#FFF';
        }
        return this.props.color ? this.props.color : '#FFF';
      }
    }, {
      key: "iconColor",
      get: function get() {
        if (this.props.iconColor) {
          return this.props.iconColor;
        }
        if (this.props.disabled) {
          return '#989898';
        }
        return '#FFF';
      }
    }, {
      key: "textTransform",
      get: function get() {
        return this.props.originalCase ? 'initial' : 'uppercase';
      }
    }, {
      key: "shortcutAlreadyAssigned",
      get: function get() {
        return this.shortcutSettings.text === this.props.text && this.shortcutSettings.shortcut === this.props.shortcut;
      }
    }, {
      key: "fontSize",
      get: function get() {
        if (this.props.fontSize) {
          return this.props.fontSize;
        }
        if (!this.props.blockFontCalculation && _state.DeckUI.layout.maximumHeight) {
          return 18;
        }
        if (!this.props.blockFontCalculation && _state.DeckUI.layout.minimumHeight) {
          return 14;
        }
      }
    }, {
      key: "onClick",
      value: function onClick() {
        var _this2 = this;
        if (!this.props.disabled && !this.rateLimited) {
          if (this.props.onClick) {
            this.props.onClick();
            this.rateLimited = true;
            this.dispose = setTimeout(function () {
              return _this2.rateLimited = false;
            }, 500);
          } else if (this.props.onPress) {
            this.onPress();
          }
        }
      }
    }, {
      key: "onPress",
      value: function onPress() {
        var _this3 = this;
        if (!this.props.disabled && !this.rateLimited) {
          if (this.props.onPress) {
            this.props.onPress();
            this.rateLimited = true;
            this.dispose = setTimeout(function () {
              return _this3.rateLimited = false;
            }, 500);
          } else if (this.props.onClick) {
            this.onClick();
          }
        }
      }
    }, {
      key: "setShortcutSettings",
      value: function setShortcutSettings(shortcutSettings) {
        this.shortcutSettings = shortcutSettings;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          shortcutSettings: this.shortcutSettings,
          setShortcutSettings: this.setShortcutSettings,
          shortcutAlreadyAssigned: this.shortcutAlreadyAssigned,
          showTooltip: this.showTooltip,
          wrongAnswer: this.wrongAnswer,
          correctAnswer: this.correctAnswer,
          backgroundColor: this.backgroundColor,
          color: this.color,
          iconColor: this.iconColor,
          textTransform: this.textTransform,
          fontSize: this.fontSize,
          onClick: this.onClick,
          onPress: this.onPress
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "shortcutSettings", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "rateLimited", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showTooltip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showTooltip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wrongAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wrongAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "backgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "backgroundColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "iconColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "iconColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textTransform", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textTransform"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shortcutAlreadyAssigned", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shortcutAlreadyAssigned"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fontSize", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "fontSize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onPress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onPress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setShortcutSettings", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setShortcutSettings"), _class2.prototype), _class2)) || _class;
};
CardButtonWrapper.displayName = 'CardButtonWrapper';
var _default = exports["default"] = CardButtonWrapper;